export default {
  email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
  password: /^([a-zA-Z0-9_-]){8,50}$/,
  resetToken: /^([A-Z0-9_-]){5,5}$/,
  user: /^(?![0-9._])(?!.*\d_)(?!.*_\d)[a-zA-Z0-9_]+$/,
  nip: /^([0-9_-]){4,4}$/,
  onlyText: /^[a-zA-Z ]{0,30}$/,
  onlyNumbers: /^[0-9]{0,10}$/,
  oneNumber: /^[0-9]{1,1}$/,
  phone: /^[0-9]{10,10}$/,
  nick: /^[a-zA-Z ]{0,10}$/,
  mobileID: /^[A-Z0-9]([\w -]*[A-Z0-9])?$/,
  cp: /^[0-9]{5,5}$/,
  rfc: /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
};
